export default (ctx, key) => {
  let strings = {
    "validate_number": "A verification code was sent to your phone number to validate your ownership. Fill in the code in the box next to your phone number",
    "duplicate_label": `Label ${ctx.label} is already used.`,
    "invalid_input": "The input data fails during validation.",
    "something_went_wrong": "Something went wrong. Please try again later.",
    "add_phone_number": "Add phone number",
    "invalid_code": `Wrong verification code! please enter the correct code you recieved on ${ctx.phonenumber}`
  }
  return strings[key]
}
